import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import NamedDto from 'modules/base/dto/NamedDto';

export class SuspicionTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.timeLimit = null;
		/** @type {number} */
		this.countLimit = null;
	}

	/**
	 * @typedef {Object} _SuspicionTableDtoProps
	 * @property {number} timeLimit
	 * @property {number} countLimit
	 *
	 * @typedef {import("../NamedDto").NamedDtoProps & _SuspicionTableDtoProps} SuspicionTableDtoProps
	 */
	/**
	 *
	 * @param {SuspicionTableDtoProps} props
	 * @returns {SuspicionTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.timeLimit = props.timeLimit;
		this.countLimit = props.countLimit;

		return this;
	}

	getAsString(key) {
		return super.getAsString(key);
	}
}

export default SuspicionTableDto;
